import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import deTexts from './CrossInnovationClassDe.json';
import enTexts from './CrossInnovationClassEn.json';
import styles from './CrossInnovationClass.module.css';
import image1 from './images/FRANKY.jpeg';
import image2 from './images/FrankyPhoto.JPG';
import image3 from './images/FrankyDrawing.png';

const CrossInnovationClass = () => {
    const { i18n } = useTranslation();
    const texts = i18n.language.startsWith('de') ? deTexts : enTexts;

    const images = [image1, image2, image3];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handlePrev = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div className={styles.crossInnovation} id="crossInnovation">
            <div className={styles.content}>
                <div className={styles.imageWrapper}>
                    <div className={styles.slider}>
                        <button
                            className={styles.arrowLeft}
                            onClick={handlePrev}
                            aria-label="Vorheriges Bild">
                            ◀
                        </button>
                        <img
                            src={images[currentImageIndex]}
                            alt={`Bild ${currentImageIndex + 1}`}
                            className={styles.image}
                        />
                        <button
                            className={styles.arrowRight}
                            onClick={handleNext}
                            aria-label="Nächstes Bild">
                            ▶
                        </button>
                    </div>
                    <div className={styles.indicator}>
                        {currentImageIndex + 1}/{images.length}
                    </div>
                </div>
                <div className={styles.description}>
                    <h2>{texts.title}</h2>
                    <p>{texts.description}</p>
                    <a
                        href="https://www.linkedin.com/posts/cross-innovation-hub_business-innovation-efrehamburg-activity-7217169373981982721-ECGL?utm_source=share&utm_medium=member_desktop&rcm=ACoAACz0_0gB8tC1bFCnoKTLrxnS4XUflGzTxKQ"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {texts.linkedInText}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CrossInnovationClass;